import { render } from "./NFTGrid.vue?vue&type=template&id=0be371b5&scoped=true&ts=true"
import script from "./NFTGrid.vue?vue&type=script&lang=ts"
export * from "./NFTGrid.vue?vue&type=script&lang=ts"

import "./NFTGrid.vue?vue&type=style&index=0&id=0be371b5&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0be371b5"]])

export default __exports__